/* eslint-disable max-len */
export function minusIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="2" viewBox="0 0 13 2" fill="none">
      <line x1="0.75" y1="1.25" x2="12.25" y2="1.25" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );

}

export function plusIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
      <line x1="0.75" y1="6.25" x2="12.25" y2="6.25" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="6.75" y1="0.75" x2="6.75" y2="12.25" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );

}
